import { render, staticRenderFns } from "./gzhOAList.vue?vue&type=template&id=1f65d516&scoped=true&"
import script from "./gzhOAList.vue?vue&type=script&lang=js&"
export * from "./gzhOAList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65d516",
  null
  
)

export default component.exports